define('drops/entityFiltersPanel/entityFiltersPanel',[
    'jquery',
    'underscore',
    'lq/drop',
    'lq/style',
    './entityFiltersPanelItem'
], function ($, _, Drop, Style, EntityFiltersPanelItem) {
    'use strict';

    var defaults = {
        data: {
        }
    };

    var EntityFiltersPanel = function (options) {
        Drop.call(this, $('<div />'), defaults, options);

        this.$panel = $('<div class="entity-filters-panel" />')
            .appendTo(this.$element);

        Style.renderStyles(this, null, this.$panel);

        this.items = [];
    };

    Drop.extend(EntityFiltersPanel, Drop);

    EntityFiltersPanel.typeName = 'EntityFiltersPanel';

    EntityFiltersPanel.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();
    };

    EntityFiltersPanel.prototype.postRender = function () {
        var self = this;
        _.each(this.piping.dropFactory.getAllDrops(), function(drop) {
            if (drop.type !== 'EntityFilter') return;
            drop.withOnFilterAdded(self.addEntityFilter.bind(self));
        });
    };
    
    EntityFiltersPanel.prototype.addEntityFilter = function (filterInstance) {
        if (filterInstance.targetDrop.data.name !== this.data.targetDrop) return;

        filterInstance.withOnceRemoved(this.removeEntityFilter.bind(this, filterInstance));

        var item = new EntityFiltersPanelItem(filterInstance);

        Style.renderStyles(this, null, item.$element, this.data.itemStyles, 'normal');
        
        this.$panel.append(item.$element);

        item.show();

        this.items.push(item);
    };
    
    EntityFiltersPanel.prototype.removeEntityFilter = function (filterInstance) {
        var item = _.find(this.items, function (item) {
            return item.filterInstance === filterInstance;
        });
        if (item) {
            item.remove();

            var index = _.indexOf(this.items, item);
            this.items.splice(index, 1);
        }
    };

    EntityFiltersPanel.prototype.expand = function () {
        this.$panel.removeClass('collapsed');
        this.triggerEventIfEnabled('expanded');
    };

    EntityFiltersPanel.prototype.collapse = function () {
        this.$panel.addClass('collapsed');
        this.triggerEventIfEnabled('collapsed');
    };
    
    return EntityFiltersPanel;
});


